import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import ProfileCard from './ProfileCard';
// Declare fbq as global function
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface ResultsProps {
  profile: {
    profile: string;
    title: string;
    description: string;
    recommendations: string[];
  };
}
const Results: React.FC<ResultsProps> = ({
  profile
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    // Track results view event with profile type
    if (window.fbq) {
      window.fbq('track', 'ViewResults', {
        profileType: profile.profile
      });
    }
    const handleScroll = () => {
      setIsSticky(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [profile.profile]);
  return <section className="w-full py-16 px-4 bg-[#0A1020]" data-id="element-306">
      <div className="max-w-5xl mx-auto" data-id="element-307">
        <div className="text-center mb-12" data-id="element-308">
          <div className="inline-block p-3 bg-[#10C96C] bg-opacity-20 rounded-full mb-4" data-id="element-309">
            <CheckCircleIcon className="w-8 h-8 text-[#10C96C]" data-id="element-310" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-311">
            Ditt quiz är klart!
          </h2>
          <p className="text-xl text-gray-300" data-id="element-312">
            Baserat på dina svar har vi tagit fram en personlig plan för dig.
          </p>
          <p className="text-lg text-[#0EB7FF] mt-4 font-medium" data-id="element-313">
            Vi rekommenderar VeeloBooster för din profil
          </p>
        </div>
        <ProfileCard profile={profile} data-id="element-314" />
        <div className="mt-12" data-id="element-315">
          <button onClick={() => setExpanded(!expanded)} className="flex items-center justify-between w-full p-4 bg-gray-900 rounded-t-lg text-left text-lg font-medium" data-id="element-316">
            <span data-id="element-317">Detaljer och forskning om VeeloBooster</span>
            {expanded ? <ChevronUpIcon className="w-5 h-5" data-id="element-318" /> : <ChevronDownIcon className="w-5 h-5" data-id="element-319" />}
          </button>
          {expanded && <div className="p-6 bg-gray-900 bg-opacity-50 rounded-b-lg" data-id="element-320">
              {profile.profile === 'erection' && <div className="space-y-4" data-id="element-321">
                  <h4 className="font-semibold" data-id="element-322">
                    Så fungerar VeeloBooster för erektionskvalitet:
                  </h4>
                  <p className="text-gray-300 text-sm" data-id="element-323">
                    VeeloBooster ökar blodflödet till corpora cavernosa
                    (svällkropparna) i penis. Dessa kammare fylls med blod vid
                    upphetsning, och ju mer blod de kan samla, desto kraftigare
                    blir erektionen. Epimedium Icariin (Horny Goat Weed) har i
                    studier visat sig förbättra blodcirkulationen och stödja
                    erektionsförmågan.
                  </p>
                  <div className="p-3 bg-gray-800 rounded text-xs border-l-2 border-[#0EB7FF]" data-id="element-324">
                    <p data-id="element-325">
                      VeeloBooster innehåller L-arginin och L-citrullin som
                      hjälper till att producera kväveoxid, vilket vidgar
                      blodkärlen och ökar blodflödet.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'libido' && <div className="space-y-4" data-id="element-326">
                  <h4 className="font-semibold" data-id="element-327">
                    Så fungerar VeeloBooster för ökad sexlust:
                  </h4>
                  <p className="text-gray-300 text-sm" data-id="element-328">
                    VeeloBooster innehåller Eurycoma longifolia (Longjack) som
                    har använts i århundraden för att öka libido och sexuell
                    prestationsförmåga. Den hjälper till att öka koncentrationen
                    av testosteron, det hormon som är ansvarigt för den manliga
                    sexdriften och har stark påverkan på erektionskvalitet och
                    orgasmintensitet.
                  </p>
                  <div className="p-3 bg-gray-800 rounded text-xs border-l-2 border-[#0EB7FF]" data-id="element-329">
                    <p data-id="element-330">
                      Serenoa Repens i VeeloBooster används för att höja
                      testosteronnivån, vilket ger ökad energi och sexuell
                      aptit.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'energy' && <div className="space-y-4" data-id="element-331">
                  <h4 className="font-semibold" data-id="element-332">
                    Så fungerar VeeloBooster för energi och uthållighet:
                  </h4>
                  <p className="text-gray-300 text-sm" data-id="element-333">
                    VeeloBooster är rik på ämnen som ger dig extra energi så att
                    du kan njuta av din nya kraft och virilitet hela natten.
                    Kombinationen av adaptogener och energigivande örter hjälper
                    till att öka uthålligheten både i vardagen och under sexuell
                    aktivitet.
                  </p>
                  <div className="p-3 bg-gray-800 rounded text-xs border-l-2 border-[#0EB7FF]" data-id="element-334">
                    <p data-id="element-335">
                      Nässelrot i VeeloBooster fungerar som en mild men effektiv
                      aromatas-blockerare som kontrollerar östrogen och främjar
                      högre testosteronnivåer.
                    </p>
                  </div>
                </div>}
              {profile.profile === 'balance' && <div className="space-y-4" data-id="element-336">
                  <h4 className="font-semibold" data-id="element-337">
                    Så fungerar VeeloBooster för sexuell helhetsbalans:
                  </h4>
                  <p className="text-gray-300 text-sm" data-id="element-338">
                    VeeloBooster arbetar på fyra fronter för att förbättra din
                    sexuella hälsa: hälsan hos corpora cavernosa, hormonbalans,
                    cellregenerering, samt energi och kondition. Denna
                    helhetsapproach ger en balanserad förbättring av alla
                    aspekter av din sexuella prestationsförmåga.
                  </p>
                  <div className="p-3 bg-gray-800 rounded text-xs border-l-2 border-[#0EB7FF]" data-id="element-339">
                    <p data-id="element-340">
                      "Den unika formeln hos VeeloBooster-piller möter högsta
                      internationella standard gällande kvalitet och säkerhet.
                      Dess ingredienser är de bästa möjliga för att ge mer
                      intensiva erektioner, hög sexuell njutning och
                      penishälsa."
                    </p>
                  </div>
                </div>}
              {profile.profile === 'medical' && <div className="space-y-4" data-id="element-341">
                  <h4 className="font-semibold" data-id="element-342">Medicinsk rådgivning:</h4>
                  <p className="text-gray-300 text-sm" data-id="element-343">
                    Det är viktigt att alltid följa medicinska råd från din
                    läkare. Vissa kosttillskott kan interagera med mediciner
                    eller vara olämpliga vid vissa medicinska tillstånd.
                    Konsultera alltid sjukvården innan du börjar med nya
                    kosttillskott.
                  </p>
                </div>}
            </div>}
        </div>
      </div>
      {isSticky && <div className="fixed bottom-0 left-0 w-full bg-gray-900 py-3 px-4 shadow-lg z-50" data-id="element-344">
          <div className="max-w-5xl mx-auto flex justify-between items-center" data-id="element-345">
            <div className="text-sm md:text-base" data-id="element-346">
              <span className="font-semibold" data-id="element-347">Din profil:</span> {profile.title}
            </div>
            <a href="https://www.fasttrack39.com/Q2F67GN8/2K64K71K/" className="px-4 py-2 bg-[#0EB7FF] text-black font-semibold rounded-md text-sm md:text-base" data-id="element-348">
              Prova VeeloBooster nu
            </a>
          </div>
        </div>}
    </section>;
};
export default Results;